<template>
  <v-card
    class="flex-grow-1"
    rounded="lg"
    outlined
    :style="'border-color: ' + maincolor">
    <v-container>
      <v-row class="pa-3">
        <v-col cols="12" md="12" class="py-0">
          <v-img
            :lazy-src="require('../assets/default.jpg')"
            :src="job.urlpic ? job.urlpic : ''"
            max-height="70"
            max-width="70">
          </v-img>
        </v-col>
        <v-col cols="12" md="12" class="pt-0">
          <span class="caption font-weight-bold">{{ job.com_name }}</span>
          <h1 class="text-md-h5 font-weight-bold">
            <router-link :to="{ name: 'Jobdetail', query: { jobid: job.job_id } }">
              {{ job.job_name }}
            </router-link>
          </h1>
          <div class="my-3">
            <v-chip
              class="mr-1 mb-1"
              color="primary"
              small
              dark>
              <v-icon left small>
                mdi-map-marker
              </v-icon>
              {{ job.job_location }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="orange"
              small
              dark>
              <v-icon left small>
                mdi-av-timer
              </v-icon>
              {{ job.job_type }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="deep-orange"
              small
              dark>
              <v-icon left small>
                mdi-cash-multiple
              </v-icon>
              {{ job.job_salary | rupiahformat }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="red darken-4"
              small
              dark>
              <v-icon left small>
                mdi-calendar-range
              </v-icon>
              {{ job.job_valid }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="green"
              small
              dark>
              <v-icon left small>
                mdi-account-hard-hat
              </v-icon>
              {{ job.job_special }}
            </v-chip>
          </div>
          <p>
            {{ job.job_preview }}
          </p>
        </v-col>
        <v-col cols="12" md="12" class="py-0" v-if="alertdata.show">
          <alertsp :alertdata="alertdata"></alertsp>
        </v-col>
        <v-col cols="12" md="6" class="pt-0">
          <v-btn
            v-if="!isapply"
            :loading="loading.apply"
            :disabled="loading.apply"
            depressed
            large
            block
            :color="maincolor"
            @click="applyJob(job.job_id)"
            class="white--text">
            Apply Now
          </v-btn>
          <v-btn
            v-if="isapply"
            :disabled="true"
            depressed
            large
            block
            :color="maincolor"
            class="white--text">
            Applied
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="pt-0">
          <v-btn
            v-if="!issave"
            :loading="loading.save"
            :disabled="loading.save"
            depressed
            large
            block
            outlined
            :color="maincolor"
            @click="bookmarkJob(job.job_id)">
            <v-icon left>
              mdi-bookmark-outline
            </v-icon>
            Save It
          </v-btn>
          <v-btn
            v-if="issave"
            :loading="loading.unsave"
            :disabled="loading.unsave"
            depressed
            large
            block
            outlined
            :color="maincolor"
            @click="unsaveJob(job.job_id)">
            <v-icon left>
              mdi-bookmark
            </v-icon>
            Saved
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="appconfirm.modal"
      max-width="350">
      <v-card>
        <v-card-title class="headline">
          {{ appconfirm.title }}
        </v-card-title>
        <v-card-text>
          {{ appconfirm.text }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            :to="{ name: 'Register' }">
            Sign Up
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :to="{ name: 'Login' }">
            Log In
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import qs from 'qs';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';
import Alertsp from './Alert.vue';

export default {
  props: ['job'],
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      apply: false,
      save: false,
    },
    appconfirm: {
      modal: false,
      title: 'Apply for job',
      text: 'Only registered job seekers can apply the job, please Sign Up and Sign In as a jobseeker first. Thank you',
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    isapply: false,
    issave: false,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userjob',
      'usersjob',
    ]),
  },
  mounted() {
    this.isapply = this.userjob.includes(this.job.job_id);
    this.issave = this.usersjob.includes(this.job.job_id);
    // console.log(this.job.job_id);
    // console.log(this.usersjob);
    // this.getJeniskerja();
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
  },
  methods: {
    unsaveJob(jobid) {
      this.appconfirm.modal = false;
      if (this.tokenscr && this.userrole === 'jobseeker') {
        this.alertdata.show = true;
        this.loading.save = true;
        this.axios
          .post(
            this.api + '/api/jobs/unsave',
            qs.stringify({
              job_id: jobid,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.issave = false;
                this.$store.commit('REMOVE_JOBSAVE', resdata.data);
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Job vacancies were successfully unsaved';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.save = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.save = false;
          });
      } else {
        this.appconfirm.modal = true;
        this.appconfirm.title = 'Save for job';
        this.appconfirm.text = 'Only registered job seekers can unsave the job, please Sign Up and Sign In as a jobseeker first. Thank you';
      }
    },
    bookmarkJob(jobid) {
      // console.log('Bookmark ' + jobid);
      this.appconfirm.modal = false;
      if (this.tokenscr && this.userrole === 'jobseeker') {
        this.alertdata.show = true;
        this.loading.save = true;
        this.axios
          .post(
            this.api + '/api/jobs/save',
            qs.stringify({
              job_id: jobid,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.issave = true;
                this.$store.commit('ADD_JOBSAVE', resdata.data);
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Job vacancies were successfully saved';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.save = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.save = false;
          });
      } else {
        this.appconfirm.modal = true;
        this.appconfirm.title = 'Save for job';
        this.appconfirm.text = 'Only registered job seekers can save the job, please Sign Up and Sign In as a jobseeker first. Thank you';
      }
    },
    applyJob(jobid) {
      this.appconfirm.modal = false;
      if (this.tokenscr && this.userrole === 'jobseeker') {
        this.alertdata.show = true;
        this.loading.apply = true;
        this.axios
          .post(
            this.api + '/api/jobs/apply',
            qs.stringify({
              job_id: jobid,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.isapply = true;
                this.$store.commit('ADD_JOBAPP', resdata.data);
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Job vacancies were successfully applied';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.apply = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.apply = false;
          });
      } else {
        this.appconfirm.modal = true;
        this.appconfirm.title = 'Apply for job';
        this.appconfirm.text = 'Only registered job seekers can apply the job, please Sign Up and Sign In as a jobseeker first. Thank you';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>